export default "January 3, 2026";